import Project from './icons/projects.svg';
import Cutomer from './icons/customer.svg';
import Tune from './icons/tune.svg';
import Units from './icons/units.svg';
import Bell from './icons/bell.svg';
import Logo from './icons/logo.svg';
import Profile from './icons/icon-profile-pict.svg';
import Excel from './icons/icon-excel.svg';
import PDF from './icons/icon-pdf.svg';
import ContactDetails from './icons/icon-contacts-details.svg';
import Contacts from './icons/icon-contacts.svg';
import LotsUnitsDetails from './icons/icon-lots-units-details.svg';
import OfficeDetails from './icons/icon-offices-details.svg';
import ProjectHandDetails from './icons/icon-projects-hand-details.svg';
import workorder from './icons/workorder.svg';
import Delete from './icons/trash-filled.svg';
import DisabledDelete from './icons/trash-filled-grey.svg';
import OperationManagement from './icons/icon-operation-management.svg';
import PlanReview from './icons/icon-plan-review.svg';
import PlanLibrary from './icons/icon_planLibrary.svg';
import bulkSchedule from './icons/icon-bulk-schedule.svg';
import ScheduleBalancing from './icons/icon_schedule_balancing.svg';
import Dollar from './icons/icon-dollar.svg';
import poUpload from './icons/icon-upload.svg';
import poDownload from './icons/icon-download.svg';
import scheduleCalendar from './icons/icon-schedule-calendar.svg';
import Notes from './icons/icon-notes.svg';
import FileDownload from './icons/file-download.svg';
import FilterDots from './icons/icon-filterDots.svg';
import IconClose from './icons/icon_close.svg';
import IconReports from './icons/icon_reports.svg';
import IconCheckFillGreen from './icons/ic-check-circle-fill-green.svg';
import IconCheckFillGrey from './icons/ic-check-circle-fill-grey.svg';
import IconUnitsLotsDetails from './icons/units-lots-details.svg';
import IconMasterContacts from './icons/icon-contacts-master.svg';
import IconMasterLeaves from './icons/icon-leaves-master.svg';
import IconMasterEmployees from './icons/icon-employee-master.svg';
import IconMasterServiceCategories from './icons/service-categories-master.svg';
import IconMasterServiceGroups from './icons/service-groups-master.svg';
import IconEquipments from './icons/icon-equipments.svg';
import IconServiceType from './icons/icon-ServiceType.svg';
import IconRebateCompanies from './icons/icon-rebate-companies.svg';
import IconProjectSubtype from './icons/project-subtype.svg';
import IconDenied from './icons/icon_denied.svg';
import IconDeniedGraphics from './icons/icon_denied_graphics.svg';
import IconCalendar from './icons/icon_calendar.svg';
import IconWarning from './icons/ic_warning.svg';
import IconScheduleBalancing from './icons/icon_schedule_balance.svg';
import IconCSVDownload from './icons/icon_csv_download.svg';

export const Icons = {
  Project,
  Cutomer,
  Tune,
  Units,
  Bell,
  Logo,
  Profile,
  Excel,
  PDF,
  ContactDetails,
  Contacts,
  LotsUnitsDetails,
  OfficeDetails,
  ProjectHandDetails,
  workorder,
  Delete,
  DisabledDelete,
  OperationManagement,
  PlanReview,
  PlanLibrary,
  bulkSchedule,
  ScheduleBalancing,
  Dollar,
  poUpload,
  poDownload,
  scheduleCalendar,
  Notes,
  FileDownload,
  FilterDots,
  IconClose,
  IconReports,
  IconCheckFillGreen,
  IconCheckFillGrey,
  IconUnitsLotsDetails,
  IconMasterContacts,
  IconMasterLeaves,
  IconMasterEmployees,
  IconMasterServiceCategories,
  IconMasterServiceGroups,
  IconEquipments,
  IconServiceType,
  IconRebateCompanies,
  IconProjectSubtype,
  IconDenied,
  IconDeniedGraphics,
  IconCalendar,
  IconWarning,
  IconScheduleBalancing,
  IconCSVDownload,
};
